// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DailyReport_wrapper__1fOj2"};